import { PhoneOnlyPatitentActions } from 'apps/wrapper/src/components/shared/contact/patient-actions/phone-only-patient-actions';
import { FC } from 'react';
import { formatPhoneNumber } from '../../../../../../utils/formatter';
import { PatientDetails, PatientInfo, PatientInfoWrapper, PatientName } from './contact-info.styles';

export interface PhoneOnlyContactInfoProps {
  phoneNumber: string;
}

export const PhoneOnlyContactInfo: FC<PhoneOnlyContactInfoProps> = (props) => {
  return (
    <PatientInfoWrapper>
      <PatientInfo>
        <PatientName>{formatPhoneNumber(props.phoneNumber)}</PatientName>
        <PatientDetails>{formatPhoneNumber(props.phoneNumber)}</PatientDetails>
      </PatientInfo>
      <PhoneOnlyPatitentActions phoneNumber={props.phoneNumber} />
    </PatientInfoWrapper>
  );
};
